import { createContext, useContext } from 'react';

/**
 * Carries the active sub-tab id down to DataIntervention/ActionIntervention so
 * they can render the per-view HeadlineBand (handoffV5 §12.2) without every
 * sub-tab having to pass its own id. EngineShell sets this when it renders the
 * active tab.
 */
export const SubTabContext = createContext<string | null>(null);
export const useSubTabView = () => useContext(SubTabContext);

/**
 * Carries the alert scenario from a deep link (§15.2) so ActionIntervention
 * can pre-run its diagnostic once when the operator arrives from an alert.
 */
export const SubTabScenarioContext = createContext<string | null>(null);
export const useSubTabScenario = () => useContext(SubTabScenarioContext);
